// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { WappMode } from '@weblite-wapps/protocol'
import { WappSession } from '../../common'
import { wappSystemApi } from '../../setup/root'

const modeToDefaultIndexNameMap = {
  [WappMode.MAIN]: 'index',
  [WappMode.STATIC]: 'index',
  [WappMode.INLINE]: 'index-inline',
  [WappMode.OVERLAY]: 'index-overlay',
}

export function useSrcURL({
  wappId,
  mode,
  servIndexes,
}: Pick<WappSession, 'wappId' | 'mode' | 'servIndexes'>) {
  const indexName = servIndexes?.[mode] || modeToDefaultIndexNameMap[mode]
  const wappVersion = wappSystemApi.getWappVersion(wappId)

  return window.config
    ? `${window.config.frontend.WAPPS_HOST}/wapp/${wappId}/${wappVersion}/${indexName}.html?origin=${window.origin}`
    : ''
}
